import { CREATE_ARBEITSBEREICH_STATION } from '@/domain/mitarbeiter/features/rotationsplan/hooks/useCreateArbeitsbereichStation/graphql/mutation';
import {
  Rotationsplan_CreateArbeitsbereichStationMutation,
  Rotationsplan_CreateArbeitsbereichStationMutationVariables,
} from '@/gql/graphql';
import { useMutation } from '@apollo/client/react';
import { useCallback } from 'react';

export function useCreateArbeitsbereichStation() {
  const [execute, result] = useMutation<
    Rotationsplan_CreateArbeitsbereichStationMutation,
    Rotationsplan_CreateArbeitsbereichStationMutationVariables
  >(CREATE_ARBEITSBEREICH_STATION, {
    refetchQueries: ['mitarbeiter_rotationsplanById'],
    awaitRefetchQueries: true,
  });

  const createArbeitsbereichStation = useCallback(
    (variables: Rotationsplan_CreateArbeitsbereichStationMutationVariables) => {
      return execute({
        variables,
      });
    },
    [execute],
  );

  return [createArbeitsbereichStation, result] as const;
}
